export interface LiveTransactionLike {
  _id?: string;
  createdAt?: string | number | Date;
  status?: string;
  [key: string]: unknown;
}

export const LIVE_TRANSACTION_MAX_AGE_MS = 3 * 60 * 60 * 1000;

const ACTIVE_LIVE_TRANSACTION_STATUSES = new Set([
  "approved",
  "awaitingsettlement",
  "broadcasting",
  "confirming",
  "pending",
  "pendingscreening",
  "processing",
  "queued",
]);

const TERMINAL_LIVE_TRANSACTION_STATUSES = new Set([
  "cancelled",
  "canceled",
  "claimed",
  "complete",
  "completed",
  "confirmed",
  "expired",
  "failed",
  "rejected",
  "reversed",
]);

export function normalizeLiveTransactionStatus(status: unknown): string {
  return String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, "");
}

export function isTerminalLiveTransactionStatus(status: unknown): boolean {
  return TERMINAL_LIVE_TRANSACTION_STATUSES.has(
    normalizeLiveTransactionStatus(status)
  );
}

export function isActiveLiveTransactionStatus(status: unknown): boolean {
  return ACTIVE_LIVE_TRANSACTION_STATUSES.has(
    normalizeLiveTransactionStatus(status)
  );
}

export function isLiveTransactionFresh(
  transaction: LiveTransactionLike,
  now = Date.now()
): boolean {
  if (!transaction.createdAt) {
    return false;
  }

  const createdAt = new Date(transaction.createdAt).getTime();
  if (!Number.isFinite(createdAt)) {
    return false;
  }

  return now - createdAt <= LIVE_TRANSACTION_MAX_AGE_MS;
}

export function isVisibleLiveTransaction(
  transaction: LiveTransactionLike,
  now = Date.now()
): boolean {
  return (
    !isTerminalLiveTransactionStatus(transaction.status) &&
    isActiveLiveTransactionStatus(transaction.status) &&
    isLiveTransactionFresh(transaction, now)
  );
}

export function filterVisibleLiveTransactions<
  TTransaction extends LiveTransactionLike,
>(transactions: TTransaction[], now = Date.now()): TTransaction[] {
  return transactions.filter((transaction) =>
    isVisibleLiveTransaction(transaction, now)
  );
}
